// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export let environment = {
  production: false,
  // backendUrl: 'http://localhost:10180/',
  backendUrl: 'https://rejestracje2.dev.usos.edu.pl:4040/',
  // backendUrl: "https://usosweb.demo.usos.edu.pl:9443/",
  lang: 'pl',
  usoswebUrl: 'http://usosweb.vagrant.xy/',
  userId: null,
  casUserId: null,
  sessionId: null
};

declare var globalParams;

try {
// @ts-ignore
  environment.usoswebUrl = sys_www_path;

  // @ts-ignore
  Object.assign(environment, JSGLOBALS);

  Object.assign(environment, globalParams);

  // @ts-ignore
  environment.lang = lang;
} catch (e) {
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
